import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogTitle,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogTitle,
  Divider,
  Grid,
  IconButton,
  // IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import {
  AppPrimaryButton,
  ConfirmDialog,
  // AppSelectWithKeys,
} from 'shared/components/AppComponents';
// import DeleteIcon from '@mui/icons-material/Delete';
// import LaunchIcon from '@mui/icons-material/Launch';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
// import { ReactComponent as Plus } from 'assets/images/ic_plus.svg';
import AddIcon from '@mui/icons-material/Add';
// import CompletedAssessmentOverview from 'modules/risk-management/risk-assessments/components/CompletedAssessmentOverview';
// import { ITemplate } from 'modules/risk-management/risk-assessments/components/RunRiskAssessment';
// import { RiskAssessmentService } from 'services/RiskAssessmentService';
import QuickRunAssessment from './QuickRunAssessment';
import CompletedAssessmentOverview from 'modules/risk-management/risk-assessments/components/CompletedAssessmentOverview';
import RiskAssessmentDetail from 'modules/risk-management/risk-assessments/risk-assessments-detail/components/RiskAssessmentDetail';
// import TEMPLATES from '../../../../risk-management/risk-assessments/Templates.json';
import { RiskAssessmentService } from 'services/RiskAssessmentService';
import { IAssessment } from 'modules/risk-management/risk-assessments/Main';
import DateFnsAdapter from '@date-io/date-fns';
import DoneIcon from '@mui/icons-material/Done';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Toast, Utils } from 'shared/helpers';
import { BROADCAST_MESSAGES } from 'shared/Constants';
import useBroadCast from 'shared/hooks/useBroadCast';
import SendIcon from '@mui/icons-material/Send';
import DeleteIcon from '@mui/icons-material/Delete';
import { BaseApplicationState } from 'state/baseapplication/Reducer';
import { useSelector } from 'react-redux';

const dateFns = new DateFnsAdapter();

interface LinkedAssessmentsProps {
  aiSystemId?: string;
  datasetId?: string;
  type: 'Dataset' | 'AI';
  onClickSendAssessment: () => void;
  showSendAssessment: boolean;
}

const LinkedAssessments: React.FC<LinkedAssessmentsProps> = (props) => {
  const {
    aiSystemId,
    type,
    datasetId,
    onClickSendAssessment,
    showSendAssessment,
  } = props;
  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [showAssessmentDetaiFor, setShowAssessmentDetailFor] = useState('');
  const [showRunAssessment, setShowRunAssessment] = useState(false);
  const { orgACLConfig }: BaseApplicationState = useSelector(
    (state: any) => state.baseAppState
  );
  const [assessmentToEdit, setAssessmentToEdit] = useState<any>();
  const [linkedAsssessments, setLinkedAsssessments] = useState<IAssessment[]>(
    []
  );
  const [quickEditTitle, setQuickEditTitle] = useState('');
  const [deleteAssessmentId, setDeleteAssessmentId] = useState('');

  // API Calls
  const loadLinkedAssessments = (): void => {
    setIsLoadingDetail(true);
    const baseQuery = `offset=1&limit=100&assessmentType=all&sort=asc`;
    RiskAssessmentService.getExternalAssessments(
      aiSystemId
        ? `${baseQuery}&aiInventoryId=${aiSystemId}`
        : `${baseQuery}&datasetId=${datasetId}`
    )
      .then((response) => {
        const { data } = response.data;
        const { assessment } = data;

        setLinkedAsssessments(assessment.assessment);
      })
      .catch(() => {})
      .finally(() => {
        setIsLoadingDetail(false);
      });
  };

  // UI Actions
  const actionOnDeleteAssessment = (): void => {
    RiskAssessmentService.deleteExternalAssessment(deleteAssessmentId)
      .then(() => {
        Toast.showSuccessMessage('Assessment deleted successfully');
        setDeleteAssessmentId('');
        loadLinkedAssessments();
      })
      .catch((error) => {
        Utils.handleErrorResponse(error);
        setDeleteAssessmentId('');
      });
  };

  const actionEditAssessment = (assessment: IAssessment): void => {
    RiskAssessmentService.getAssessmentDetail(assessment._id)
      .then((response) => {
        const { data } = response.data;
        if (data.length > 0) {
          setAssessmentToEdit({
            datasets:
              assessment.entityType === 'Dataset'
                ? [
                    {
                      _id: assessment.enitityId,
                      title: assessment.enitityId,
                    },
                  ]
                : [],
            aiSystems:
              assessment.entityType === 'AI System'
                ? [
                    {
                      _id: assessment.enitityId,
                      title: assessment.enitityId,
                    },
                  ]
                : [],
            assessmentIds: [assessment],
            template: data[0].template[0],
            userResponses: data[0].responses || {},
          });
        }
      })
      .catch((error: any) => {
        Toast.showInfoMessage(error.message);
      });
  };

  // Hooks
  useEffect(() => {
    if (aiSystemId || datasetId) loadLinkedAssessments();
  }, [aiSystemId, datasetId]);

  useBroadCast({
    eventName: BROADCAST_MESSAGES.RELOAD_ASSESSMENTS,
    onBroadCast: () => {
      loadLinkedAssessments();
    },
  });

  // UI Elements
  return (
    <>
      <Box className="sub-box">
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          spacing={{ xs: 2, sm: 0 }}
          className="heading"
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: '1.25rem', sm: '1.75rem', md: '2rem' },
              lineHeight: 1.3,
            }}
          >
            Risk Assessments
          </Typography>
          <Stack
            direction="row"
            spacing={{ xs: 1, sm: 2, md: 5 }}
            alignItems="center"
            flexWrap="wrap"
            useFlexGap
            sx={{
              width: { xs: '100%', sm: 'auto' },
              justifyContent: { xs: 'flex-start', sm: 'flex-end' },
            }}
          >
            {showSendAssessment &&
              orgACLConfig.aiInventory?.includes(
                'aiInventory.aiSystem.aiInventory.view.riskAssessment.sendAssessment'
              ) && (
                <AppPrimaryButton
                  startIcon={<SendIcon />}
                  onClick={onClickSendAssessment}
                  className="btn-small"
                  title="Send Assessment"
                  sx={{ flex: { xs: '1 1 auto', sm: '0 0 auto' } }}
                />
              )}
            {orgACLConfig.aiInventory?.includes(
              'aiInventory.aiSystem.aiInventory.view.riskAssessment.addRunAssessment'
            ) && (
              <AppPrimaryButton
                startIcon={<AddIcon />}
                onClick={() => {
                  setShowRunAssessment(true);
                }}
                className="btn-small"
                title="Run Assessment"
                sx={{ flex: { xs: '1 1 auto', sm: '0 0 auto' } }}
              />
            )}
          </Stack>
        </Stack>
        <Box className="sub-body">
          {isLoadingDetail && (
            <Box className="empty-content">
              <CircularProgress />
            </Box>
          )}
          {!isLoadingDetail && (
            <Grid container spacing={5}>
              {linkedAsssessments.map((assessment) => (
                <Grid xs={6} item>
                  <Stack
                    justifyContent="space-between"
                    style={{
                      border: '1px solid lightgray',
                      borderRadius: '10px',
                      padding: '10px 20px',
                      height: '100%',
                      boxSizing: 'border-box',
                    }}
                  >
                    <Box style={{ flex: 1 }}>
                      <Stack
                        spacing={4}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography variant="h3">
                          {assessment.templateName}
                        </Typography>
                        <Chip
                          avatar={
                            assessment?.status === 'Completed' ? (
                              <DoneIcon />
                            ) : (
                              <AccessTimeIcon />
                            )
                          }
                          label={assessment?.status}
                          size="small"
                          color={
                            assessment?.status === 'Completed'
                              ? 'primary'
                              : 'default'
                          }
                        />
                      </Stack>
                      {assessment.assessmentType !== 'self' && (
                        <Stack
                          spacing={2}
                          className="mt-2"
                          direction="row"
                          alignItems="center"
                        >
                          <Chip size="small" label="External" />
                          <Chip
                            size="small"
                            label={
                              assessment.assessmentType === 'internal'
                                ? 'Internal'
                                : 'Vendor'
                            }
                          />
                        </Stack>
                      )}
                      <Stack
                        spacing={2}
                        direction="row"
                        alignItems="center"
                        className="mt-4"
                      >
                        <CalendarMonthIcon />
                        <Typography>
                          Started Date:{' '}
                          {dateFns
                            .date(assessment.assessmentDate)
                            .toDateString()}
                        </Typography>
                      </Stack>
                      {assessment.completionDate && (
                        <Stack
                          spacing={2}
                          direction="row"
                          alignItems="center"
                          className="mt-4"
                        >
                          <CalendarMonthIcon />
                          <Typography>
                            Completed Date:{' '}
                            {dateFns
                              .date(assessment.completionDate)
                              .toDateString()}
                          </Typography>
                        </Stack>
                      )}
                      <Stack
                        spacing={2}
                        direction="row"
                        alignItems="center"
                        className="mt-4"
                      >
                        <PermIdentityIcon />
                        <Typography>
                          Assessor: {assessment.assessorName}
                        </Typography>
                      </Stack>
                      {assessment.assessmentType !== 'self' && (
                        <Stack
                          spacing={2}
                          direction="row"
                          alignItems="center"
                          className="mt-4"
                        >
                          <PermIdentityIcon />
                          <Typography>
                            {`Recipient: ${assessment.toUserName} - ${assessment.toUserEmail}`}
                          </Typography>
                        </Stack>
                      )}
                      {assessment.assessmentType === 'self' && (
                        <Stack
                          spacing={2}
                          direction="row"
                          alignItems="center"
                          className="mt-4"
                        >
                          <Typography>Version {assessment.version}</Typography>
                        </Stack>
                      )}
                    </Box>
                    <Box>
                      <Divider className="my-4" />
                      <Stack direction="row" spacing={2}>
                        {assessment.assessmentType === 'self' && (
                          <>
                            {orgACLConfig.aiInventory?.includes(
                              'aiInventory.aiSystem.aiInventory.view.riskAssessment.viewAssessmentDetails'
                            ) && (
                              <Button
                                fullWidth
                                onClick={() => {
                                  setShowAssessmentDetailFor(assessment._id);
                                }}
                                className="btn-small"
                                variant="outlined"
                                startIcon={<RemoveRedEyeIcon />}
                              >
                                View
                              </Button>
                            )}
                            {assessment?.status === 'In Progress' &&
                              orgACLConfig.aiInventory?.includes(
                                'aiInventory.aiSystem.aiInventory.view.riskAssessment.editAssessment'
                              ) && (
                                <AppPrimaryButton
                                  fullWidth
                                  className="btn-small"
                                  title="Edit"
                                  onClick={() => {
                                    setQuickEditTitle('Edit Assessment');
                                    actionEditAssessment(assessment);
                                  }}
                                  startIcon={<EditIcon />}
                                  sx={{ whiteSpace: 'nowrap' }}
                                />
                              )}
                          </>
                        )}
                        {assessment.assessmentType !== 'self' && (
                          <>
                            {assessment?.status === 'Completed' && (
                              <Button
                                onClick={() => {
                                  setShowAssessmentDetailFor(assessment._id);
                                }}
                                fullWidth
                                className="btn-small"
                                variant="outlined"
                                startIcon={<RemoveRedEyeIcon />}
                              >
                                View Results
                              </Button>
                            )}
                            {assessment?.status !== 'Completed' &&
                              orgACLConfig.aiInventory?.includes(
                                'aiInventory.aiSystem.aiInventory.view.riskAssessment.completeAssessment'
                              ) && (
                                <Button
                                  onClick={() => {
                                    setQuickEditTitle(
                                      'Complete Assessment on Behalf of Recipient'
                                    );
                                    actionEditAssessment(assessment);
                                  }}
                                  fullWidth
                                  className="btn-small"
                                  variant="outlined"
                                  startIcon={<RemoveRedEyeIcon />}
                                >
                                  Complete
                                </Button>
                              )}
                            {orgACLConfig.aiInventory?.includes(
                              'aiInventory.aiSystem.aiInventory.view.riskAssessment.deleteAssessment'
                            ) && (
                              <Button
                                variant="outlined"
                                className="btn-small"
                                onClick={() => {
                                  setDeleteAssessmentId(assessment._id);
                                }}
                              >
                                {deleteAssessmentId === assessment._id ? (
                                  <CircularProgress />
                                ) : (
                                  <DeleteIcon color="error" />
                                )}
                              </Button>
                            )}
                          </>
                        )}
                      </Stack>
                    </Box>
                  </Stack>
                </Grid>
              ))}
            </Grid>
          )}
          {linkedAsssessments.length === 0 && (
            <Box className="empty-content">
              <Typography variant="h3">No assessments linked</Typography>
              <AppPrimaryButton
                className="mt-4"
                title="Conduct First Assessment"
                onClick={() => {
                  setShowRunAssessment(true);
                }}
              />
            </Box>
          )}
        </Box>
      </Box>

      {showAssessmentDetaiFor && (
        <CompletedAssessmentOverview
          assessmentId={showAssessmentDetaiFor}
          open={!!showAssessmentDetaiFor}
          onCloseDialog={() => {
            setShowAssessmentDetailFor('');
          }}
        />
      )}
      {showRunAssessment && (
        <QuickRunAssessment
          assessmentFor={aiSystemId || datasetId}
          type={type}
          open={showRunAssessment}
          onCloseAssessment={(reload: boolean) => {
            if (reload) {
              loadLinkedAssessments();
            }
            setShowRunAssessment(false);
          }}
        />
      )}

      {assessmentToEdit && (
        <Dialog maxWidth="md" fullWidth open={assessmentToEdit}>
          <DialogTitle>
            <Stack
              direction="row"
              alignItems="flex-start"
              justifyContent="space-between"
            >
              <Typography variant="h3">{quickEditTitle}</Typography>
              <IconButton onClick={() => setAssessmentToEdit(null)}>
                <HighlightOffIcon />
              </IconButton>
            </Stack>
          </DialogTitle>
          <Divider />

          <RiskAssessmentDetail
            guestMode={false}
            aiSystems={assessmentToEdit.aiSystems}
            datasets={assessmentToEdit.datasets}
            assessmentIds={assessmentToEdit.assessmentIds}
            templateDetail={assessmentToEdit.template}
            quickEdit
            userResponses={assessmentToEdit.userResponses}
            onFinish={(reload: boolean) => {
              if (reload) {
                loadLinkedAssessments();
              }
              setAssessmentToEdit(null);
            }}
          />
        </Dialog>
      )}

      <ConfirmDialog
        title="Delete Assessment"
        subTitle="Are you sure to delete this assessment?"
        showConfirm={deleteAssessmentId}
        cancelTitle="Cancel"
        successTitle="Delete"
        onSuccess={actionOnDeleteAssessment}
        onCancel={() => setDeleteAssessmentId('')}
      />
    </>
  );
};

export default LinkedAssessments;
